import { render, staticRenderFns } from "./omt-card.vue?vue&type=template&id=23d94cf1&scoped=true&"
import script from "./omt-card.vue?vue&type=script&lang=js&"
export * from "./omt-card.vue?vue&type=script&lang=js&"
import style0 from "./omt-card.vue?vue&type=style&index=0&id=23d94cf1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d94cf1",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox})
